module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "z-backForm",
    class: {
      right: _vm.align
    }
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._t("default"), _vm._v(" "), (_vm.btns != false) ? _c('div', {
    staticClass: "btns"
  }, [_c('div', [_c('div', {
    staticClass: "back-btn blue",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.btnText || '保存'))]), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-303c70fc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/backForm.vue
// module id = 715
// module chunks = 1